









































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { LocationListModule } from '@/store/modules/locationList';
import GiganautVue from '@/components/Shared/GiganautVue';


@Component({
    name: 'LocationListSearchCriteria'
})
export default class extends GiganautVue {
 
  public dialog = false;
  public locationSearch: any = null;
  public valid = true;
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      await LocationListModule.getWorkersForSearchOptions();
    }
  }

  get searchOptions() {
      return LocationListModule.locationSearchViewModel;
  }

  get loading() {
    return LocationListModule.loading;
  }

  async search() {
    this.dialog = false;
    await LocationListModule.searchLocations()
  }
}
